export enum RightType {
    adminCanSeeAdminPage = 'A01',
    adminCanChangeAdminSettings = 'A02',
    adminCanMaintainRoles = 'A03',
    adminCanMaintainUsers = 'A04',
    adminCanMaintainPlugins = 'A05',
    adminCanSeeSystemLogs = 'A06',
    adminCanSeePlugins = 'A07',
    adminCanLoadPlugins = 'A08',
    adminCanEnableDisablePlugins = 'A09',
    adminCanDeletePlugins = 'A10',
    adminCanSeeActions = 'A11',
    adminCanMaintainActions = 'A12',
    adminCanSeeLaboratories = 'A13',
    adminCanMaintainLaboratories = 'A14',
    adminCanDeleteLaboratories = 'A15',
    adminCanDeleteRoles = 'A16',
    adminCanSeeUsers = 'A18',
    adminCanDeleteUsers = 'A19',
    adminCanMaintainLaboratoryDatabases = 'A20',
    adminCanSeeRoles = 'A21',
    adminCanSeeRegions = 'A22',
    adminCanMaintainRegions = 'A23',
    adminCanDeleteRegions = 'A24',
    adminCanMaintainRegionEsbs = 'A25', 
    adminCanAddLaboratories = 'A26',
    adminCanMaintainLaboratoryEsbs = 'A27',
    adminCanMaintainLaboratorySettings = 'A28',  
    adminCanUpdatePluginsDisplayName = 'A29',

    customersCanSeeCustomers = 'C01',
    customersCanMaintainCustomers = 'C02',
    customersCanActivateDeactivateCustomers = 'C03',
    customersCanMaintainUsersOfCustomers = 'C04',
    customersCanDeleteUsersOfCustomers = 'C05',
    customersCanExportUsersOfCustomers = 'C06',
    customersCanMaintainMappingsOfCustomers = 'C09',
    customersCanDeleteMappingsOfCustomers = 'C10',
    customersCanExportMappingsOfCustomers = 'C11',
    customersCanMaintainMappingValuesOfCustomers = 'C12',
    customersCanDeleteMappingValuesOfCustomers = 'C13',
    customersCanExportMappingValuesOfCustomers = 'C14',
    customersCanSetPluginsFlowOfCustomers = 'C15',
    customersCanActivateDeactivateFlowOfCustomers = 'C16',
    customersCanMaintainActionsOfCustomers = 'C17',
    customersCanDeleteActionsOfCustomers = 'C18',

    tasksCanSeeTasks = 'T01',
    tasksCanActionTasks = 'T02',
    tasksCanDeleteTasks = 'T03',
    tasksCanPauseTasks = 'T04',
    tasksCanResend = 'T05'   
}
